<template>
  <div class="supply">
    <img class="supply-img" :src="imgUrl" alt="banner图" />
    <div :class="activeName" @click="danclick" v-if="activeName">
      {{ btnText }}
    </div>
  </div>
</template>
<script>
  export default {
    props: ['imgUrl', 'className', 'btnText'],
    data() {
      return {}
    },
    computed: {
      activeName() {
        let name = ''
        switch (this.className) {
          case 'supply-btn':
            name = 'supply-btn'
            break
          case 'ensure-btn':
            name = 'ensure-btn'
            break
          case 'traitTwo-btn':
            name = 'traitTwo-btn'
            break
        }
        return name
      }
    },
    methods: {
      danclick() {
        this.$emit('teyaoqingdanclick')
      }
    }
  }
</script>
<style lang="scss">
  .supply {
    width: 100%;
    position: relative;
    padding: 0 xvw(20);
    .supply-img {
      width: 100%;
    }
    .supply-btn {
      position: absolute;
      top: xvw(60);
      right: xvw(51);
      font-size: xvw(28);
      color: #0c77fb;
      width: xvw(160);
      height: xvw(40);
    }
    .ensure-btn {
      position: absolute;
      top: 5.5vw;
      right: 5.6vw;
      font-size: 3.73333vw;
      color: #0c77fb;
      width: 21.33333vw;
      height: 5.33333vw;
    }
    .traitTwo-btn {
      position: absolute;
      bottom: xvw(50);
      right: 0;
      left: 0;
      text-align: center;
      font-size: 3.73333vw;
      color: #4d76f9;
    }
  }
</style>
